import { Injectable } from '@angular/core';
import { BaseClient } from '../common/client/base.client';
import { SvcClients } from '../common/client/SvcClients';
import { AIAnalysisRequest, AIAnalysisResult, AIAnalysisReview } from '../common/entity/ai-analysis.model';

@Injectable({
  providedIn: 'root',
})
export class AIAnalysisClient extends BaseClient {
  constructor() {
    super();
  }

  public analyzeAmount(request: AIAnalysisRequest, message?: string): Promise<{ result: AIAnalysisResult; requestId: string }> {
    return this.post(
      SvcClients.ResourceSvc,
      'AIAmountAnalysis/AnalyzeAmount',
      request,
      message
    );
  }

  public submitReview(review: AIAnalysisReview, message?: string): Promise<any> {
    return this.post(
      SvcClients.ResourceSvc,
      'AIAmountAnalysis/SubmitReview',
      review,
      message
    );
  }
}
